import * as constants from './constants';

const initialState = {
  loading: false,
  data: [],
  error: null,
  namesMap: {},
};

// eslint-disable-next-line import/prefer-default-export
export const manufacturersReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_MANUFACTURERS:
    return { ...state, loading: true };
  case constants.GET_MANUFACTURERS_SUCCESS: {
    return {
      ...state,
      loading: false,
      data: action.payload,
      namesMap: action.payload?.reduce((result, { id, name }) => {
        if(Array.isArray(result?.[name]) && !result[name].includes(id)) {
          return {
            ...result,
            [name]: result[name].concat([id]),
          };
        }

        return {
          ...result,
          [name]: [id],
        };
      }, state.namesMap),
    };
  }
  case constants.GET_MANUFACTURERS_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_MANUFACTURERS:
    return initialState;
  default:
    return state;
  }
};
